import React from 'react';

type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

/**
 * Freehand drawing tool (PLAT-11289). A bare squiggle: the mark itself, not an
 * implement. `HighlightIcon` is a highlighter pen and already means "highlight"
 * on the transcript, so it is not reused here.
 */
const DrawFreehandIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'var(--text-secondary)',
    strokeWidth = '1.6',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <path
        d="M1.5 10.5C3 6 4.5 3.5 6 4.5c1.5 1 0 7 1.75 7.5C9.5 12.5 11 4 12.5 4c1.2 0 1.4 4 2 7.5"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DrawFreehandIcon;
